<template lang="pug">
  .page
    section
      b-container
        h1 SUBMISSION SUCCESSFUL
        h4 Thank you for your application to the Wall Collective!
        p Our curators will review your submission and communicate updates via email. Please remember to check your spam folder for communications.
</template>

<script>

export default {
  name: 'RegisterOk',
  components: {
  },
};
</script>

<style lang="scss" scoped>
.icon {
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/RegisterArtistOk.vue